import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=3940c7da&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260608114340/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3940c7da')) {
      api.createRecord('3940c7da', component.options)
    } else {
      api.reload('3940c7da', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=3940c7da&", function () {
      api.rerender('3940c7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/form/checkbox.vue"
export default component.exports